// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Personaleintrag, PersonaleintragDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useUpdatePersonaleintrag(): (
  taetigkeitsberichtId: string,
  requestBody: PersonaleintragDaten
) => Promise<Personaleintrag> {
  const getAPI = useGetApi();
  return useCallback(
    async (taetigkeitsberichtId, requestBody) =>
      (await getAPI()).personaleintraege.updatePersonaleintrag({
        taetigkeitsberichtId,
        requestBody,
      }),
    [getAPI]
  );
}
